import apiRequest from './api';

export function getBusinessTypes(token) {
  return apiRequest('/business-types', {
    method: 'GET',
    token,
  });
}
